import config from "../config";

export default async function requestHandler(path, method, authorization, body = null) {
    const url = `${config.isDev ? "http://" : "https://"}${config.backend}${config.isDev ? `:${config.port}` : ""}/${path}`;

    const options = {
        method: method,
        headers: {
            "Content-Type": "application/json",
            Authorization: authorization,
        },
    };

    if (body !== null) {
        options.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            if (response.status === 401) {
                console.error("Unauthorized request. Token might be expired.");
            }
            let errMsg = `HTTP error! status: ${response.status}`;
            try {
                const errData = await response.json();
                if (errData && errData.message) {
                    errMsg = errData.message;
                }
            } catch (_) {}
            
            const errorObj = new Error(errMsg);
            errorObj.status = response.status;
            throw errorObj;
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(`API Request Failed for ${path}:`, error);
        throw error;
    }
}
